"use strict";

exports.__esModule = true;
exports.PredefinedCommentsScreen = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _App = require("../../App");
var _Core = require("../../Core");
var _PredefinedCommentsPanels = require("./PredefinedCommentsPanels");
var _styles = require("../styles.js");
var _PredefinedCommentsContext = require("../PredefinedCommentsContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PredefinedCommentsScreen = exports.PredefinedCommentsScreen = function PredefinedCommentsScreen() {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_PredefinedCommentsContext.PredefinedCommentsContext),
    settings = _useContext2.settings,
    updateSettings = _useContext2.updateSettings,
    unchanged = _useContext2.unchanged,
    loading = _useContext2.loading;
  var handleSave = function handleSave() {
    updateSettings(settings);
  };
  return loading ? /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null) : /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("PredefinedCommentsScreen.Screen.Title", "Plant Settings"),
    "data-testid": "PredefinedCommentsScreen.Screen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("PredefinedCommentsScreen.Screen.Title", "Predefined Comments"),
    "data-testid": "PredefinedCommentsScreen.Screen.Navbar"
  }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_Core.RightToolbarContent, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "PredefinedCommentsScreen.Screen.Save",
    intent: _core.Intent.PRIMARY,
    icon: "floppy-disk",
    onClick: handleSave,
    disabled: unchanged
  }, translate("PredefinedCommentsScreen.Screen.SaveAll", "Save All")))), /*#__PURE__*/_react["default"].createElement(_styles.PredefinedCommentsScreenContainer, {
    style: {
      maxHeight: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_PredefinedCommentsPanels.PredefinedCommentsPanel, null)));
};